// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__1QR4M","main":"Button_main__39SZB","outline":"Button_outline__1jwtJ","disabled":"Button_disabled__2OQOs","disabledBtn":"Button_disabledBtn__N7zhp"};